export default __webpack_public_path__ + "static/media/30mm blue cap.66ee48ff.jpeg";